<ng-container *ngTemplateOutlet="content; context: { activeIcon: (activeIcon$ | async) }"></ng-container>


<ng-template #content let-activeIcon="activeIcon">
  <section class="side-menu-content flex-sm-column {{
      isExpanded ? 'expanded d-md-block d-sm-flex' : 'd-md-none'
    }}">
    <div class="d-flex flex-row justify-content-between mb-md-5 d-none d-sm-flex d-md-flex">
      <div class="side-menu-info">
        <div class="d-flex flex-row justify-content-between mb-md-5 d-none d-sm-block d-md-flex info-menu">
          <ng-container *ngFor="let item of leftMenuModelIcons">
            <ng-container *ngIf="
                item.isVisible !== false &&
                item.isSubmenu === false &&
                item.isInfoMenu === true &&
                item.group === 'session'
              ">
              <div class="{{ item.classMenu }}">
                <div class="side-menu-item user-name">
                  <!-- (mouseover)="item.isHover = true" (mouseout)="item.isHover = false"> -->
                  <mat-panel-title>
                    <sit-icon [icon]="
                        item.event?.action === activeIcon || item.isHover
                          ? item.tagSelected
                          : item.tag
                      " alt="{{ item.alt }}" [sizeClass]="'icon-size-40'"></sit-icon>
                    <span *ngIf="item?.textInline" class="addText">{{ item.textInline }}
                    </span>
                    <sit-icon-button class="ml-50" (click)="this.toggleFooter()" [alt]="'layer'" [icon]="Icon.dots"
                      [sizeClass]="'icon-size-32'"></sit-icon-button>
                  </mat-panel-title>
                </div>
                <mat-divider class="full-width {{ item.classDivider }} divider-info-foot" color="primary"></mat-divider>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <ng-container *ngIf="userName">
          <div class="d-sm-flex date date-icon pt-sm-1 d-none">
            <sit-icon [icon]="Icon.account_w" [alt]="'Icono de usuario'" [tooltip]="'Icono de usuario'"
              [sizeClass]="'icon-size-16'"></sit-icon>
            <span class="calendar ml-8">{{ userName }}</span>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="pt-16"></div>
    <div class="d-flex flex-column collapse full-sm-height container-icon">
      <ng-container *ngFor="let item of leftMenuModelIcons">
        <ng-container *ngIf="
            item.isVisible !== false &&
            item.isSubmenu === false &&
            item.isInfoMenu === false
          ">
          <div class="{{ item.classMenu }} item-content"
            [ngClass]="{'active': item.event?.action === activeIcon || hasActiveSubmenus(item, activeIcon) }">
            <div class="side-menu-item" (click)="dispatchEvent(item.dispatcher$, item.event)"
              (mouseover)="item.isHover = true" (mouseout)="item.isHover = false"
              (keydown.enter)="item.isTriggered = true" (keydown.space)="item.isTriggered = true">
              <mat-accordion class="d-none d-md-block d-sm-block" style="width: 100%;"
                (click)="dispatchEvent(item.dispatcher$, item.event)">
                <mat-expansion-panel (click)="
                    item.isSubmenu === false && item.event?.action
                      ? dispatchEvent(item.dispatcher$, item.event)
                      : $event.stopPropagation()
                  " [hideToggle]="item.isSubmenu === false && item.event?.action" (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title [ngClass]="{
                      active: item.event?.action === activeIcon || item.isHover
                    }">
                      <!--  Menu izquierdo -->
                      <sit-icon [icon]="
                          (item.event?.action === activeIcon || item.isHover || hasActiveSubmenus(item, activeIcon))
                            ? (item?.tagAux ? item.tagAux : item.tagSelected)
                            : (item?.tagAux ? item.tagAux : item.tag)
                        " alt="{{ item.alt }}" [tooltip]="item.tooltipTag" [sizeClass]="'icon-size-40'"></sit-icon>
                      <span class="addText">{{ item.tooltipTag }}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <ng-container *ngFor="let submenu of leftMenuModelIcons">
                    <ng-container *ngIf="
                        submenu.isSubmenu === true &&
                        submenu.group === item.group
                      ">
                      <div [ngClass]="{
                        submenu: true,
                          active:
                            submenu.event?.action === activeIcon ||
                            submenu.isHover
                        }" (click)="
                          dispatchEvent(submenu.dispatcher$, submenu.event)
                        " class="container-sub">
                        <button matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          matTooltip="{{ submenu.tooltipTag }}">
                          <sit-icon [icon]="
                              submenu.event?.action === activeIcon ||
                              submenu.isHover
                                ? submenu.tagSelected
                                : submenu.tag
                            " alt="{{ submenu.alt }}" [tabIndex]="-1" [sizeClass]="'icon-size-32'"></sit-icon>
                          <span class="addText text-submenu">{{ submenu.tooltipTag }}
                          </span>
                        </button>
                      </div>
                      <mat-divider class="full-widht {{ item.classDivider }}" color="primary"></mat-divider>
                    </ng-container>
                  </ng-container>
                </mat-expansion-panel>
              </mat-accordion>
              <!-- Definition of left menu icons -->
              <button class="side-menu-item-icon d-sm-none d-md-none" matTooltipPosition="above" class="btn-item"
                matTooltipClass="custom-tooltip" matTooltip="{{ item.tooltipTag }}">
                <sit-icon [icon]="
                    (item.event?.action === activeIcon || item.isHover || hasActiveSubmenus(item, activeIcon))
                      ? item.tagSelected
                      : item.tag
                  " alt="{{ item.alt }}" [tabIndex]="-1" sizeClass="icon-size-32"></sit-icon>
                <span [ngClass]="{
                    active: item.event?.action === activeIcon || item.isHover
                  }" class="addText">{{ item.tooltipTag }}</span>
              </button>

              <ul [ngClass]="{'d-flex': item.isTriggered }">
                <ng-container *ngFor="let submenu of leftMenuModelIcons" class="">
                  <ng-container *ngIf="
                      submenu.isSubmenu === true && submenu.group === item.group
                    ">
                    <div [ngClass]="{
                        active:
                          submenu.event?.action === activeIcon ||
                          submenu.isHover
                      }" class="submenu-element d-sm-none d-md-none" (click)="
                        dispatchEvent(submenu.dispatcher$, submenu.event)
                      " (mouseover)="submenu.isHover = true" (mouseout)="submenu.isHover = false" (focusout)="
                        submenu.isLastItemSubMenu && (item.isTriggered = false)
                      ">
                      <button class="submenu" matTooltipPosition="above" matTooltipClass="custom-tooltip"
                        matTooltip="{{ submenu.tooltipTag }}">
                        <sit-icon [icon]="
                            submenu.event?.action === activeIcon ||
                            submenu.isHover
                              ? submenu.tagSelected
                              : submenu.tag" sizeClass="icon-size-32" [sizeClass]="'icon-size-32'"
                          alt="{{ submenu.alt }}" [tabIndex]="-1"></sit-icon>
                      </button>
                    </div>
                  </ng-container>
                </ng-container>
              </ul>
            </div>
            <mat-divider class="full-widht {{ item.classDivider }}" color="primary"></mat-divider>
          </div>
        </ng-container>
        <!-- Separador -->
        <ng-container *ngIf="item?.isSeparator">
          <div class="separator"></div>
        </ng-container>

      </ng-container>
    </div>
    <!-- menu inferior responsive -->
    <div class="d-flex flex-row justify-content-between mb-md-5 d-none d-sm-block d-md-flex info-menu set-content">
      <ng-container *ngFor="let item of leftMenuModelIcons">
        <ng-container *ngIf="
            item.isVisible !== false &&
            item.isSubmenu === false &&
            item.isInfoMenu === true &&
            item.group !== 'session' &&
            item.textInline !== 'Información Adicional' &&
            item.textInline !== 'Reportes'
          ">
          <div class="{{ item.classMenu }}">
            <div class="side-menu-item" (click)="dispatchEvent(item.dispatcher$, item.event)"
              (mouseover)="item.isHover = true" (mouseout)="item.isHover = false">
              <mat-accordion class="d-none d-md-block d-sm-block" style="width: 100%;">
                <mat-expansion-panel (click)="
                item.isSubmenu === false && item.event?.actionType
                  ? dispatchEvent(item.dispatcher$, item.event)
                  : $event.stopPropagation()
              " (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                  [hideToggle]="item.isSubmenu === false && item.event?.actionType">
                  <mat-expansion-panel-header [ngClass]="{
                      active: item.event?.action === activeIcon || item.isHover
                    }">
                    <mat-panel-title>
                      <!-- Menu superior derecho -->
                      <sit-icon [icon]="
                          item.event?.action === activeIcon || item.isHover
                            ? item.tagSelected
                            : (item?.tagAux ? item.tagAux : item.tag)
                        " alt="{{ item.alt }}" [sizeClass]="'icon-size-40'"></sit-icon>
                      <span *ngIf="item?.textInline" class="addText">{{ item.textInline }}
                      </span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-divider class="full-widht {{ item.classDivider }}" color="primary"></mat-divider>
                  <ng-container *ngFor="let submenu of leftMenuModelIcons">
                    <ng-container *ngIf="
                        submenu.isSubmenu === true &&
                        submenu.group === item.group
                      ">
                      <div [ngClass]="{
                          active:
                            submenu.event?.action === activeIcon ||
                            submenu.isHover
                        }" class="container-sub" (click)="
                          dispatchEvent(submenu.dispatcher$, submenu.event)
                        ">
                        <button [ngClass]="{
                          active:
                            submenu.event?.action === activeIcon
                        }" class="submenu" matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          matTooltip="{{ submenu.tooltipTag }}" [ngClass]="{
                            'd-none': !submenu.isVisible, 'ml-0': !submenu.tag
                          }">
                          <sit-icon *ngIf="submenu.tag" [icon]="
                              submenu.event?.action === activeIcon ||
                              submenu.isHover
                                ? submenu.tagSelected
                                : submenu.tag
                            " alt="{{ submenu.alt }}" [tabIndex]="-1"></sit-icon>
                          <span class="addText text-submenu">{{ submenu.tooltipTag }}
                          </span>
                        </button>
                      </div>
                      <mat-divider class="full-widht {{ item.classDivider }}" color="primary"></mat-divider>
                    </ng-container>
                  </ng-container>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            <!-- <mat-divider class="full-width {{ item.classDivider }} divider-info-foot" color="primary"></mat-divider> -->

          </div>
        </ng-container>
      </ng-container>
      <br>
      <div class="content-logos">
        <sit-icon [icon]="Icon.logo_menu_almeria" [alt]="'Icono de Almeria'" [tooltip]="'Icono de alemria'"
          [sizeClass]="'icon-size-120'"></sit-icon>
        <sit-icon [icon]="Icon.logo_union_europea" [alt]="'Icono de Union Europea'" [tooltip]="'Icono de Hora'"
          [sizeClass]="'icon-size-120'"></sit-icon>
      </div>
    </div>
  </section>
  <div class="side-menu-backdrop {{ isExpanded ? 'd-md-block' : 'd-md-none' }}"></div>
  <ng-container *ngIf="isHidden">
    <div class="menu d-flex d-md-flex cont-items flex-md-column">
      <div>
        <div class="handle-container">
          <div class="handle d-none d-md-block"></div>
        </div>
        <section class="title d-none d-md-flex pt-md-15" SheetBottom classContainer="menu">
          <sit-icon-button [alt]="'Cerrar'" [icon]="Icon.close_ng" [colorClass]="'text-white'" class="text-blue"
            [sizeClass]="'icon-size-16'" (click)="this.isHidden = !this.isHidden">
          </sit-icon-button>
        </section>
        <div class="d-md-block d-sm-block pr-2 pt-md-15">
          <ng-container *ngFor="let item of leftMenuModelIcons">
            <ng-container *ngIf="
          item.isVisible !== false &&
          item.isSubmenu === false &&
          item.isInfoMenu === true &&
          item.group === 'session'
        ">
              <ng-container *ngFor="let submenu of leftMenuModelIcons">
                <ng-container *ngIf="
                submenu.isSubmenu === true &&
                submenu.group === item.group
              ">
                  <div [ngClass]="{
                  active:
                    submenu.event?.action === activeIcon ||
                    submenu.isHover
                }" class="container-sub" (click)="
                  dispatchEvent(submenu.dispatcher$, submenu.event)
                ">
                    <button class="submenu" matTooltipPosition="above" matTooltipClass="custom-tooltip"
                      matTooltip="{{ submenu.tooltipTag }}" [ngClass]="{
                    'd-none': !submenu.isVisible, 'ml-0': !submenu.tag
                  }">
                      <sit-icon *ngIf="submenu.tag" [icon]="
                      submenu.event?.action === activeIcon ||
                      submenu.isHover
                        ? submenu.tagSelected
                        : submenu.tag
                    " alt="{{ submenu.alt }}" [tabIndex]="-1"></sit-icon>
                      <span class="addText text-submenu">{{ submenu.tooltipTag }}
                      </span>
                    </button>
                  </div>
                  <mat-divider class="full-widht {{ item.classDivider }}" color="primary"></mat-divider>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>